export enum GetFaqActionTypes {
    REQUEST = '@@faq/get-faq/request',
    SUCCESS = '@@faq/get-faq/success',
    ERROR = '@@faq/get-faq/error'
}

export enum GetFaqNotificationsActionTypes {
    REQUEST = '@@faq/get-faq-notifications/request',
    SUCCESS = '@@faq/get-faq-notifications/success',
    ERROR = '@@faq/get-faq-notifications/error'
}

export enum GetFaqOnboardingMessageActionTypes {
    REQUEST = '@@faq/get-faq-onboardingmessage/request',
    SUCCESS = '@@faq/get-faq-onboardingmessage/success',
    ERROR =   '@@faq/get-faq-onboardingmessage/error'
}